import { useApiPrivateRequest } from "@/shared/hooks/useApi";
import { McpTool } from "../models/McpTool";

export const useUpdateMcpTool = () => {
  const {
    data: updatedTool,
    call,
    isLoading: isUpdating,
    isFailed: isUpdateFailed,
  } = useApiPrivateRequest<McpTool>((response) => new McpTool(response));

  const updateMcpTool = async (
    toolName: string,
    name: string,
    url: string,
    authorizationToken?: string,
  ) => {
    const payload: any = {
      name,
      url,
    };

    // Only include authorization token if provided
    if (authorizationToken !== undefined) {
      payload.authorizationToken = authorizationToken;
    }

    await call(`/llm/mcpTools/${toolName}`, "PUT", undefined, payload);
  };

  return {
    updatedTool,
    updateMcpTool,
    isUpdating,
    isUpdateFailed,
  };
};
